import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Icon,
  Input,
  Modal,
  Drawer,
  notification,
  Row,
  Select,
  Table,
  Tooltip
} from 'antd'
import _ from 'lodash'
import moment from 'moment'
import React, { PureComponent, useState } from 'react'

import { connect } from 'react-redux'
import GetEachFormFields from '../../../components/_utils/appFormUtils'
import { getPushPathWrapper, getUrlParams } from '../../../routes'

import {
  ArticleTypeList,
  chooseEmailModalFxn,
  Countries,
  CustomCkEditor,
  DesignationList,
  InputBox,
  mentionsFeeds,
  NotificationBox,
  ProcessList
} from '../../../components/_utils/appUtils'

import { addCourierFxn, addSubscriptionActivityFxn } from '../action'
import Request from '../../../request'

@Form.create()
class AddCourierDrawer extends PureComponent {
  state = {
    journal: '',
    mode: '',
    copies: '',
    date: '',
    volumeName: '',
    issues: []

  }
  events = {
    removeStateCountry: (index) => {
      let cloneArr = _.clone(this.state.courierDetails)
      cloneArr.splice(index, 1)
      this.setState({
        courierDetails: cloneArr
      })
    }
  }

  constructor(props) {
    super(props)
    const doneInvoices = props.invoiceData.filter(invoice => invoice.status === 'done')
    const doneJournals = doneInvoices.flatMap(invoice => invoice.journals)
    this.state = {
      courierDetails: [],
      journalsList: doneJournals
    }
  }

  componentDidMount() {
    // this.loadJournalList()
    this.getJournalList()
    let data = getUrlParams('article.onlineSubmission', this.props.pathname)
    if (!!data) {
      let { id } = data
      this.setFormValuesFxn(id)
    }
  }

  resetFormData = () => {
    const { dispatch, form } = this.props
    form.setFieldsValue({
      journal: '',
      mode: '',
      copies: '',
      date: '',
      volumeName: '',
      issues: []
    })
  }

  async AddCourierDetails() {
    const {
      form: { getFieldValue, setFieldsValue }
    } = this.props
    let journal = getFieldValue('journal') ? getFieldValue('journal') : undefined

    let copies = getFieldValue('copies') ? getFieldValue('copies') : undefined
    let volumeName = getFieldValue('volumeName') ? getFieldValue('volumeName') : undefined
    let issues = getFieldValue('issues') ? getFieldValue('issues') : undefined
    if (journal == undefined) {
      notification.error({
        message: 'Please choose Journal Name.'
      })
      return
    }


    if (copies == undefined) {
      notification.error({
        message: 'Please select copies'
      })
      return
    }
    if (volumeName == undefined) {
      notification.error({
        message: 'Please select volume'
      })
      return
    }
    if (issues == undefined) {
      notification.error({
        message: 'Please select issues'
      })
      return
    }
    let obj = {
      journal: journal,
      copies: copies,
      volumeName: volumeName,
      issues: issues
    }
    let cloneD = _.clone(this.state.courierDetails)

    this.setState({ courierDetails: [...cloneD, obj] })

    // }
  }

  getJournalList = async () => {
    let { data } = await Request.journalName()
    let journalList = []
    _.each(data, item => {
      journalList.push({
        _id: item._id,
        value: item.slugJournal,
        display: item.name
      })
    })

    this.setState({ journalNameList: journalList })
  }


  chooseDocument = e => {
    let { name, files } = e.target
    if (files && files.length) {
      this.setState({ [name]: files[0] })
    }
  }
  getJournalsVolumeData = async (id) => {
    let { data } = await Request.getJournalsVolumeList({ journalId: id })
    let volumeList = []
    _.each(data, (item) => {
      volumeList.push({
        _id: item._id,
        name: item.volumeName
      })
    })

    this.setState({ journalVolumeList: volumeList })
  }
  getJournalsIssueData = params => {
    return new Promise(async resolve => {
      const {
        form: { getFieldDecorator, getFieldValue, setFieldsValue },
        loading
      } = this.props
      let journal = getFieldValue('journal') ? getFieldValue('journal') : undefined

      let { data } = await Request.getJournalIssue({ journalId: journal, volumeId: params })
      this.setState({ total: data.total })
      let issueList = []
      _.each(data, (item) => {
        issueList.push({
          _id: item._id,
          name: item.issueName
        })
      })

      this.setState({ journalIssueList: issueList })
    })
  }

  handleSubmit = e => {
    const { dispatch, form } = this.props
    let urlObj = getUrlParams('singleGeneralSubscription', window.location.pathname)
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        valData.generalSubscriptionId = urlObj.id
        if (this.props.missingIssues) {
          valData.missingIssues = this.props.missingIssues
        }
        valData.courierDetails = this.state.courierDetails

        let { success, message } = await dispatch(addCourierFxn(valData))
        if (success) {
          notification.success({
            message: message
          })
          this.props.reloadData()
          this.resetFormData()
          this.props.onClose()
        }
      }
    })


  }

  render() {
    const {
      form: { getFieldDecorator, getFieldValue, setFieldsValue },
      loading
    } = this.props
    const { edit, journalListArr, lastArticleNo, visibleAddAuthor } = this.state

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 24 },
        md: { span: 24 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 },
        md: { span: 24 }
      }
    }

    const inputSchma = {
      fields: [


        // {
        //   label: 'Tracking No',
        //   key: 'trackingNo',
        //   required: true,
        //   placeholder: 'Tracking No',
        // },
        {
          label: 'Date',
          key: 'date',
          required: true,
          placeholder: 'Date',
          type: 'date'
        },
        {
          label: 'Mode',
          key: 'mode',
          required: true,
          placeholder: 'Mode'
        },
        {
          title: 'Tracking No',
          name: 'TrackingNo',
          key: 'TrackingNo',
          dataIndex: 'TrackingNo'
        }


      ],
      multiFields: [

        {
          label: 'Journal Name',
          key: 'journal',
          placeholder: 'Select',
          type: 'select',
          required: true,
          keyAccessor: x => x._id,
          valueAccessor: x => x.name,
          options: this.state.journalsList,
          onChange: (e) => {
            setFieldsValue({ journal: e })
            this.getJournalsVolumeData(e)
          }
        },
        {
          label: 'Copies',
          key: 'copies',
          required: true,
          placeholder: 'Copies',
          type: 'number'

        },
        {
          label: 'Volume',
          key: 'volumeName',
          placeholder: 'Select',
          type: 'select',
          required: true,
          keyAccessor: x => x.name,
          valueAccessor: x => x.name,
          options: this.state.journalVolumeList,
          onChange: async (selectedVolume) => {
            setFieldsValue({
              volumeName: selectedVolume
            })
            const selectedObj = this.state.journalVolumeList.find(
              x => x.name === selectedVolume
            )
            await this.getJournalsIssueData(selectedObj._id)
            setFieldsValue({
              volumeId: selectedObj._id
            })
          }
        },
        {
          label: 'Issue',
          key: 'issues',
          placeholder: 'Select',
          type: 'select',
          required: true,
          mode: 'multiple',
          keyAccessor: x => x.name,
          valueAccessor: x => x.name,
          options: this.state.journalIssueList,

          onChange: (e) => {
            setFieldsValue({ issues: e })
          }
        },
        {
          key: 'add',
          span: 4,
          customField: (
            <InputBox title={'Add'}>
              <a className='btn mt10' type='primary'
                 onClick={() => {
                   this.AddCourierDetails()
                 }}
                 style={{ backgroundColor: '#1556bc', textColor: 'white', color: 'white' }}>
                ADD
              </a>
            </InputBox>
          )
        }
      ]


    }
    const assignColumns = [
      {
        title: 'Journal Name',
        key: 'journal',
        dataIndex: 'journal',
        render: (record, index) => {
          const item = this.state.journalsList.find(j => j._id == record)

          return <>{item ? item.name : '-'}</>
        }
      },
      {
        title: 'Volume',
        key: 'volumeName',
        dataIndex: 'volumeName'

      },
      {
        title: 'Issues',
        key: 'issues',
        dataIndex: 'issues',
        render: (item) => {
          return (
            <div>
              {item && item.length ? item.join(', ') : null}
            </div>
          )
        }
      },
      {
        title: 'Copies',
        key: 'copies',
        dataIndex: 'copies'
      },
      {
        title: 'Action',
        key: 'action',
        dataIndex: 'action',
        render: (item, record, index) => {
          return (
            <Icon type={'close'}
                  style={{ color: 'red' }}
                  onClick={() => {
                    this.events.removeStateCountry(index)
                  }} />
          )
        }
      }

    ]
    return (
      <Drawer
        title={`${this.props.missingIssues === true ? 'Add Missing Details' : 'Add Courier Details'}`}
        width={'45%'}
        visible={this.props.visible}
        maskClosable={true}
        placement='right'
        onClose={this.props.onClose}>
        <Card bordered={true}>
          <Form
            onSubmit={this.handleSubmit}
            hideRequiredMark
            className={'inputForm'}>
            <Row gutter={16}>
              <Col span={24}>
                <Card bordered={true}>
                  <Row gutter={16}>
                    {inputSchma.fields.map((item, key) => {
                      return (
                        !item.hidden && (
                          <Col
                            span={item.span ? item.span : 8}
                            md={item.span ? item.span : 8}
                            sm={12}
                            xs={24}
                            key={key}>
                            {item.customField ? (
                              item.customField
                            ) : (
                              <GetEachFormFields
                                item={item}
                                getFieldDecorator={getFieldDecorator}
                                formItemLayout={formItemLayout}
                              />
                            )}
                          </Col>
                        )
                      )
                    })}

                  </Row>
                  <Row gutter={16}>
                    {inputSchma.multiFields.map((item, key) => {
                      return (
                        !item.hidden && (
                          <Col
                            span={item.span ? item.span : 6}
                            md={item.span ? item.span : 12}
                            sm={12}
                            xs={24}
                            key={key}>
                            {item.customField ? (
                              item.customField
                            ) : (
                              <GetEachFormFields
                                item={item}
                                getFieldDecorator={getFieldDecorator}
                                formItemLayout={formItemLayout}
                              />
                            )}
                          </Col>
                        )
                      )
                    })}

                  </Row>
                </Card>
              </Col>

            </Row>
            <Row gutter={16}>
              <Table dataSource={this.state.courierDetails}
                     className={'table table-bordered'}
                     bordered={true} size={'small'}
                     pagination={false} columns={assignColumns} />
            </Row>

            <Form.Item style={{ marginTop: 32 }}>
              <Button type='primary' htmlType='submit'>
                SUBMIT
              </Button>
            </Form.Item>
          </Form>


        </Card>
      </Drawer>
    )
  }
}

const mapStateToProps = ({ global, router }) => ({
  loading: global.buttonLoading,
  categories: global.categories,
  search: router.location.search,
  pathname: router.location.pathname

})
const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}

export default connect(mapStateToProps,
  mapDispatchToProps
)(AddCourierDrawer)
